import { REQUEST_SERVICE_RECOMMANDATION_DETAILED, FETCH_SERVICE_RECOMMANDATION_DETAILED, ADD_TO_CART_FROM_RECOMMENDED, REQUEST_ADD_TO_CART_FROM_RECOMMENDED } from '../actions/Types'

const recommanderReducerDetail = (state={loading: false, data: []}, action) => {
    switch (action.type){
        case REQUEST_SERVICE_RECOMMANDATION_DETAILED:
            return {loading: true, data: []}
        case FETCH_SERVICE_RECOMMANDATION_DETAILED:
            return {loading: false,data: action.payload}
        case REQUEST_ADD_TO_CART_FROM_RECOMMENDED:
            return {...state, loading: true}
        case ADD_TO_CART_FROM_RECOMMENDED:
            return {loading: false, data: action.payload.recommandedServices}
        default:
            return state
    }
}

export default recommanderReducerDetail
